module.exports = __webpack_public_path__ + "assets/img/fotow.eedbfc02.png";